/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `event` - Event
 * * `opportunity` - Opportunity
 * * `account` - Account
 * * `other` - Other
 */
export enum EventExternalObjectContentTypeEnum {
    EVENT = 'event',
    OPPORTUNITY = 'opportunity',
    ACCOUNT = 'account',
    OTHER = 'other',
}
